'use client';

import React from 'react';
import { SkeletonElement } from '../common';
import { css } from '@bts-web/utils-style-engine';
import { FilledSpinnerIos } from '../common/svgIcons';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { getOrdersListTranslations } from './utils/getOrdersListTranslations';
import { OrdersListButtonSkeleton } from './OrdersListButtonSkeleton';
import OrdersListSkeleton from './OrdersListSkeleton';

function OrdersListScreenSkeleton() {
  const { t } = useClientTranslation();

  const translations = getOrdersListTranslations(t);

  return (
    <>
      <div
        className={css({
          backgroundColor: 'neutrals.fill_quaternary',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
        })}
      >
        <div
          className={css({
            display: 'flex',
            flexDirection: 'row',
            gap: 'small',
            width: '100%',
            padding: 'small',
            justifyContent: 'center',
          })}
        >
          {Array.from({ length: 4 }, (_, i) => (
            <SkeletonElement
              key={i}
              borderRadius="50px"
              width="76px"
              height="32px"
              backgroundColor="neutrals.fill_focused"
            />
          ))}
        </div>
      </div>
      <OrdersListSkeleton />
      <div
        className={css({
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: 'medium',
          justifyContent: 'space-between',
          padding: 'medium',
        })}
      >
        <OrdersListButtonSkeleton>
          {translations.stopOrderBuyTitle}
          <FilledSpinnerIos
            className={css({ color: 'neutrals.text_disabled' })}
          />
        </OrdersListButtonSkeleton>
        <OrdersListButtonSkeleton variant="secondary">
          {translations.stopOrderSellTitle}
          <FilledSpinnerIos
            className={css({
              color: 'neutrals.text_disabled',
            })}
          />
        </OrdersListButtonSkeleton>
      </div>
    </>
  );
}

export { OrdersListScreenSkeleton };
